const faq = {
  props: {
    cssSelector: "cmp-bhg-faq",
    cssSelectorMenu: "menu-faq-js",
    cssSelectorActive: "--active",
    cssSelectorQuestion: "block-quest-faq-js",
  },
  elementFound: null,

  init: function () {
    const containers = document.querySelectorAll("." + this.props.cssSelector);
    if (!containers) {
      return;
    }
    this.initFaqContainers(containers);
  },

  initFaqContainers: function (containers) {
    bcl.u.forEach(containers, ($container) => {
      this.elementFound = null;
      const menuElements = $container.querySelectorAll("." + this.props.cssSelectorMenu);
      if (menuElements) {
        this.initFaq($container, menuElements);
      }
    });
  },

  initFaq: function ($container, $elements) {
    const questionElements = $container.querySelectorAll("." + this.props.cssSelectorQuestion);
    if (!questionElements) {
      return;
    }

    this.searchInAllElements($container, $elements, questionElements);
  },

  searchInAllElements: function ($container, $elements, questionElements) {
    const url = window.location.hash,
      urlValue = url.replace("#", "");

    bcl.u.forEach($elements, ($element) => {
      if (urlValue) {
        this.callbackAnchor(urlValue, $element, questionElements, $container);
      }
      this.addEventInMenuElement($container, $element, questionElements, $elements);
    });

    if (!this.elementFound && questionElements[0]) {
      this.openQuestionsBlock(questionElements[0]);
      const menuWithQuestionBlockOpened = $container.querySelectorAll('div[data-attribute="' + questionElements[0].dataset.attribute + '"]');
      if (menuWithQuestionBlockOpened && menuWithQuestionBlockOpened.length === 1) {
        this.activateElementMenu(menuWithQuestionBlockOpened[0]);
      }
    }
  },

  addEventInMenuElement: function ($container, $element, questionElements, elements) {
    $element.addEventListener("click", () => {
      this.initMenuElements(elements);
      this.activateElementMenu($element);
      this.initQuestionsBlock($container, questionElements);
      this.findBlockQuestionFaq($container, $element);
    });
  },

  findBlockQuestionFaq: function ($container, $element) {
    const blockQuestionFaq = $container.querySelectorAll('span[data-attribute="' + $element.dataset.attribute + '"]');
    if (blockQuestionFaq && blockQuestionFaq.length == 1) {
      this.openQuestionsBlock(blockQuestionFaq[0]);
      bcl.s.dataAnchor.init($container);
    }
  },

  initQuestionsBlock: function ($container, questionElements) {
    bcl.u.forEach(questionElements, ($questionElement) => {
      this.closeQuestionsBlock($questionElement);
    });
  },

  initMenuElements: function (elements) {
    bcl.u.forEach(elements, ($element) => {
      this.deactivateElementMenu($element);
    });
  },

  callbackAnchor: function (url, $element, questionElements, $container) {
    const $elementAnchor = $element.dataset.anchor;

    if ($elementAnchor == url) {
      if (!$element.classList.contains("c-faq__nav-item-active")) {
        $element.classList.add("c-faq__nav-item-active");
      }
      this.goToAnchor($element);
      this.findBlockQuestionFaq($container, $element);
      this.elementFound = $element;
    }

    if ($elementAnchor != url) {
      if ($element.classList.contains("c-faq__nav-item-active")) {
        $element.classList.remove("c-faq__nav-item-active");
      }
      this.searchInQuestionBlockElements(url, $element.dataset.attribute, questionElements);
    }
  },

  searchInQuestionBlockElements: function (urlValue, elementAttribute, questionElements) {
    for (let i = 0; i < questionElements.length; i++) {
      const $questionElement = questionElements[i];
      if ($questionElement.dataset.attribute == elementAttribute) {
        const $accordionSelected = $questionElement.querySelectorAll('a[data-anchor="' + urlValue + '"]');
        if ($accordionSelected && $accordionSelected.length == 1) {
          this.openAndGoAtQuestionsBlock($questionElement, $accordionSelected[0]);
          this.elementFound = $accordionSelected;
          break;
        }
      }
    }
  },

  openQuestionsBlock: function ($blockElement) {
    bcl.u.removeClass($blockElement, "hidden");
  },

  closeQuestionsBlock: function ($blockElement) {
    bcl.u.addClass($blockElement, "hidden");
  },

  activateElementMenu: function ($element) {
    bcl.u.addClass($element, "c-faq__nav-item-active");
  },

  deactivateElementMenu: function ($element) {
    bcl.u.removeClass($element, "c-faq__nav-item-active");
  },

  goToAnchor: function ($element) {
    bcl.u.goToWithScroll({
      top: bcl.s.dataAnchor.getScrollTop($element) + bcl.s.dataAnchor.props.offset,
    });
  },

  openAndGoAtQuestionsBlock: function ($questionElement, $elementSelected) {
    this.openQuestionsBlock($questionElement);
    this.goToAnchor($elementSelected);
    bcl.c.accordion.processClick($elementSelected);
  },
};

export default faq;
